












import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
export default defineComponent({
    props: {
        link: {
            type: String,
            default: '',
        },
        needNewTab: {
            type: [Boolean, Function],
            default: true,
        },
        defaultStyle: {
            type: Object as PropType<{ color: string; fontWeight: number}>,
        },
        hoverStyle: {
            type: Object as PropType<{ color: string; fontWeight: number}>,
        },
    },
    setup(props) {
        const newTab = computed(() => {
            if (typeof props.needNewTab === 'function') {
                return (props.needNewTab as Function)();
            }
            return props.needNewTab;
        });
        function handleLinkMoveEnter(e: Event) {
            if (!props.hoverStyle) {
                return;
            }
            const target = e.target as HTMLElement;
            target.style.color = props.hoverStyle?.color || '';
        }
        function handleLinkMoveLeave(e: Event) {
            if (!props.defaultStyle) {
                return;
            }
            const target = e.target as HTMLElement;
            target.style.color = props.defaultStyle?.color || '';
        }
        return {
            newTab,
            handleLinkMoveEnter,
            handleLinkMoveLeave,
        };
    },
});
